import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../shared/services/admin.service';
import {LocaleService} from '../../../shared/services/locale.service';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';

@Component({
    selector: 'app-modal-admin-company-register',
    templateUrl: './modal-admin-company-register.component.html',
    styleUrls: ['./modal-admin-company-register.component.scss'],
    standalone: false
})
export class ModalAdminCompanyRegisterComponent implements OnInit {

  public entity = {
    id: '',
    emailAddress: '',
    firstName: '',
    lastName: '',
    infix: '',
    phoneNumber: '',
    allowEmailNotifications: true,
    isSubscribedToNewsletter: true,
    companyName: '',
    registrationNumber: '',
    visitAddress: {
      street: '',
      number: '',
      numberSuffix: '',
      postalCode: '',
      city: '',
      country: '',
      latitude: '',
      longitude: ''
    }
  };

  constructor(public activeModal: NgbActiveModal, public adminService: AdminService, public locale: LocaleService, private alertService: AlertService) {

  }

  ngOnInit(): void {
  }

  /**
   * Register company
   */
  registerCompany() {

    const { id, ...body } = this.entity;
    this.adminService.apiCompanyRegister(body).subscribe((response) => {

      this.alertService.success(alertMessages.successDataSaved);

      this.activeModal.close(true);

    });

  }
}
